export enum LinkedInPlatform {
  Aimfox = 1,
  HeyReach = 2,
}

export enum LinkedInIntegrationStatus {
  Connected = 1,
  Disconnected = 2,
}

export enum LinkedInPushStatus {
  Pushed = 1,
  Failed = 2,
  Skipped = 3,
}

export enum LinkedInCampaignStatus {
  Active = 'active',
  InProgress = 'in_progress',
  Paused = 'paused',
  Scheduled = 'scheduled',
  Completed = 'completed',
  Done = 'done',
  Finished = 'finished',
  Starting = 'starting',
  Draft = 'draft',
  Init = 'init',
  Cancelled = 'cancelled',
  Canceled = 'canceled',
  Failed = 'failed',
}

export enum LinkedInFailureReason {
  MissingRequiredField = 'LI_MISSING_REQUIRED_FIELD',
  InvalidLinkedInUrl = 'LI_INVALID_LINKEDIN_URL',
  IntegrationInactive = 'LI_INTEGRATION_INACTIVE',
  AlreadyConnected = 'LI_ALREADY_CONNECTED',
  LockedInCampaign = 'LI_LOCKED_IN_CAMPAIGN',
  CampaignNotFound = 'LI_CAMPAIGN_NOT_FOUND',
  InvalidApiKey = 'LI_INVALID_API_KEY',
  Forbidden = 'LI_FORBIDDEN',
  RateLimited = 'LI_RATE_LIMITED',
  ServerError = 'LI_SERVER_ERROR',
  CampaignNotActive = 'LI_CAMPAIGN_NOT_ACTIVE',
}
